module.exports = __webpack_public_path__ + "static/media/inner-slant-img.e1443607.png";